// extracted by mini-css-extract-plugin
export default {"programDescription":"Programs_programDescription__Dl+7V"};